import { normalize_project_id } from './tenant_settings_project_helpers';

function editable_role_id(role = {}) {
  const source_id = [role?.backend_id, role?.id, 0].find(Boolean);
  return normalize_project_id(source_id);
}

function role_form_text(value) {
  return String(value || '').trim();
}

function show_role_not_editable(component) {
  component.show_warning('Role not editable', 'This role does not have a backend id yet.');
  return false;
}

export function normalise_edit_role(role = {}) {
  const role_id = editable_role_id(role);
  if (!role_id) return null;

  const edit_form = {
    role_id,
    role_name: role_form_text(role?.title),
    role_description: role_form_text(role?.description)
  };
  return edit_form;
}

export function apply_edit_role_modal_state(component, role) {
  const edit_form = normalise_edit_role(role);
  if (!edit_form) return show_role_not_editable(component);

  component.edit_form = edit_form;
  component.show_edit_role_modal = true;
  return true;
}
